import Pagination from '@mui/material/Pagination'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useAppSelector } from 'app/hooks'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.focus,
  },
}))

const MAX_ITEM_IN_PAGE = 10
export default function AccountTable() {
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({
    curPage: 1,
    totalPage: 0,
  })
  const list = useAppSelector((s) => s.Account.list)
  useEffect(() => {
    setPagination({
      ...pagination,
      totalPage: Math.ceil(list.length / MAX_ITEM_IN_PAGE),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPagination({
      ...pagination,
      curPage: value,
    })
  }
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell>ログインID</StyledTableCell>
              <StyledTableCell>氏名</StyledTableCell>
              <StyledTableCell>権限</StyledTableCell>
              <StyledTableCell>ステータス</StyledTableCell>
              <StyledTableCell>登録日</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list
              .slice(
                (pagination.curPage - 1) * MAX_ITEM_IN_PAGE,
                pagination.curPage * MAX_ITEM_IN_PAGE
              )
              .map((account, i) => {
                return (
                  <StyledTableRow
                    key={i}
                    onClick={() => {
                      navigate(`/account/${encodeURIComponent(account.id)}`)
                    }}
                  >
                    <StyledTableCell>{`${
                      (pagination.curPage - 1) * MAX_ITEM_IN_PAGE + i + 1
                    }`}</StyledTableCell>
                    <StyledTableCell>{`${account.id}`}</StyledTableCell>
                    <StyledTableCell>{`${account.lastName} ${account.firstName}`}</StyledTableCell>
                    <StyledTableCell>
                      {
                        {
                          admin: '管理者',
                          subAdmin: '副管理者',
                          standard: '一般',
                        }[account.permission]
                      }
                    </StyledTableCell>
                    <StyledTableCell>
                      {
                        {
                          preActive: '登録済み',
                          active: '利用中',
                          deleted: '削除済み',
                        }[account.status]
                      }
                    </StyledTableCell>
                    <StyledTableCell>
                      {format(new Date(account.createdAt), 'yyyy/MM/dd')}
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack my={1} alignItems="center">
        <Pagination
          count={pagination.totalPage}
          page={pagination.curPage}
          shape="rounded"
          onChange={handleChange}
        />
      </Stack>
    </>
  )
}
